import 'css-chunksrc/client/scenes/appNotifications/notifications/styles.scss';export default {
  "notifications": "_notifications_zlxr4_1",
  "main": "_main_zlxr4_6",
  "messageList": "_messageList_zlxr4_14",
  "item": "_item_zlxr4_23",
  "comeInRight": "_comeInRight_zlxr4_1"
};